/**
 * Parse ?day=N from a URL search string and clamp to a valid 1-based day index.
 * @param {string} [search] - location.search (e.g. '?day=2')
 * @param {number} dayCount - total number of agenda days
 * @return {number}
 */
module.exports = function getAgendaDayFromQuery(search, dayCount) {
  let day = 1;
  const match = /[?&]day=(\d+)/.exec(search || '');

  if (match) {
    day = parseInt(match[1], 10);
  }

  const max = parseInt(dayCount, 10);

  if (!day || day < 1 || day > max) {
    day = 1;
  }

  return day;
};
